import { TWalletTypeId, walletTypeIdList } from '@/features/wallets/store/models/wallet.model';
import { useDashboardConfig } from '@/hooks/useDashboardConfig';
import { store } from '@/store/configuration';
import { IDashboardConfig } from '@/store/models/dashboard-config.model';

export function useConfigWalletIdsList(): TWalletTypeId[] {
  const config = useDashboardConfig();

  return getConfigWalletIdsList(config);
}

export function getConfigWalletIdsList(config?: IDashboardConfig): TWalletTypeId[] {
  if (!config) {
    config = store.getState().dashboardConfig.config as IDashboardConfig;
  }
  if (config?.settings!.wallets!.types) {
    return config
      ?.settings!.wallets!.types.map((walletType) => walletType.value as TWalletTypeId)
      .filter((walletTypeId) => walletTypeIdList.includes(walletTypeId));
  } else {
    return walletTypeIdList.map((walletTypeId) => walletTypeId);
  }
}
